/* eslint-disable react-hooks/exhaustive-deps */
import PropTypes from "prop-types";
import React, { Fragment, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import ProductGridListSingle from "../../components/product/ProductGridListSingle";
import BestProductGridSingle from "../../components/product/BestProductGridSingle";
import { getNewFilterdProducts, getNewProducts } from "../../store/actions/product-actions"; // Import your action
import { useLocation, useParams } from "react-router-dom";

const MyProductgridList = ({ products, spaceBottomClass }) => {
  const dispatch = useDispatch();
  const params = useLocation();
  const currency = useSelector((state) => state.currency);
  const { cartItems } = useSelector((state) => state.cart);
  const { wishlistItems } = useSelector((state) => state.wishlist);
  const { compareItems } = useSelector((state) => state.compare);
  const allProducts = useSelector((state) => state.products.list)
  const value = params?.search?.slice(1, 20);

  const filter = useSelector(
    (state) => state.products.filter
  );
  const object = {
    value: value,
  };
  const usedOptions = ["USED", "NEW", "REFURBISHED"];
  const usedType = usedOptions.find(option => value?.includes(option)) || "";

  const prevUsedTypeRef = useRef("");
  // useEffect(() => {
  //   if (allProducts.length === 0) {
  //     dispatch(getNewProducts());
  //   }
  // }, [dispatch, allProducts.length, object]);
  const [isFilterReady, setIsFilterReady] = useState(false);

  useEffect(() => {
    if (filter) {
      setIsFilterReady(true); // flag that filter is ready
    }
  }, [filter]);

  useEffect(() => {
    if (usedType && isFilterReady && prevUsedTypeRef.current !== usedType) {
      dispatch(getNewFilterdProducts({ ...filter, usedType }));
      prevUsedTypeRef.current = usedType;
    }
  }, [usedType, isFilterReady, filter]);


  const displayProducts = products;
  return (
    <Fragment>
      {displayProducts?.map((product) => {
        return (
          <div
            className="col-xl-4 col-sm-6"
            // style={{ overflowY: "scroll" }}
            key={product._id}
          >
            <BestProductGridSingle
              spaceBottomClass={spaceBottomClass}
              product={product}
              currency={currency}
              cartItem={cartItems.find(
                (cartItem) => cartItem._id === product._id
              )}
              wishlistItem={wishlistItems.find(
                (wishlistItem) => wishlistItem._id === product._id
              )}
              compareItem={compareItems.find(
                (compareItem) => compareItem._id === product._id
              )}
            />
          </div>
        );
      })}
    </Fragment>
  );
};

MyProductgridList.propTypes = {
  products: PropTypes.array,
  spaceBottomClass: PropTypes.string,
};

export default MyProductgridList;
